import { render, staticRenderFns } from "./tklShow.vue?vue&type=template&id=481ca5f6&scoped=true&"
import script from "./tklShow.vue?vue&type=script&lang=js&"
export * from "./tklShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481ca5f6",
  null
  
)

export default component.exports